import { PcbNodeTypes } from "@buildwithflux/models";
import { PcbNodeHelper } from "../../../nodes/pcbNodeHelper";
import { createPrimitivesForCircle } from "./createPrimitivesForCircle";
import { createPrimitivesForLine } from "./createPrimitivesForLine";
import { createShapesForPad } from "./createPrimitivesForPad";
import { createPrimitivesForPolygon } from "./createPrimitivesForPolygon";
import { createPrimitivesForRectangle } from "./createPrimitivesForRectangle";
import { createPrimitivesForRouteSegment } from "./createPrimitivesForRouteSegment";
import { createShapesForVia } from "./createPrimitivesForVia";
import { createShapesForZone } from "./createPrimitivesForZone";
/** NOTE: This function returns an empty array with inactive nodes */
export function createPrimitivesForNode(node, allNodes, stackup, tracingGraph) {
    if (!node.bakedRules.active)
        return [];
    if (!PcbNodeHelper.isNodeNotRoot(node))
        return [];
    // Pads
    if (node.type === PcbNodeTypes.pad) {
        return createShapesForPad(node, stackup);
    }
    // Vias
    if (node.type === PcbNodeTypes.via) {
        return createShapesForVia(node, stackup);
    }
    // RouteSegments
    if (node.type === PcbNodeTypes.routeSegment) {
        return createPrimitivesForRouteSegment(node, allNodes, tracingGraph, stackup);
    }
    // Circle
    if (node.type === PcbNodeTypes.circle) {
        return createPrimitivesForCircle(node, stackup);
    }
    // Rectangle
    if (node.type === PcbNodeTypes.rectangle) {
        return createPrimitivesForRectangle(node, stackup);
    }
    // Lines
    if (node.type === PcbNodeTypes.line) {
        return createPrimitivesForLine(node, stackup);
    }
    // Zones
    if (node.type === PcbNodeTypes.zone) {
        return createShapesForZone(node, stackup);
    }
    if (node.type === PcbNodeTypes.polygon) {
        return createPrimitivesForPolygon(node, stackup);
    }
    return [];
}
//# sourceMappingURL=index.js.map